(ns ycweb.app.website.cart.parts.discounts
  (:require
   [rum.core :as rum]
   [ycweb.app.website.cart.model :as model]
   [ycweb.app.website.cart.parts.items :as cart.items]
   [ycweb.components.appcommon :as appcommon]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]))

;; New callout components for modern design

;; Staff discount helper functions (must be defined before use)
(defn add-staff-discount [app-atom cart-summary-atom staff-discount-atom]
  (swap! staff-discount-atom assoc :disabled true)

  (model/apply-staff-discount app-atom
    (fn [response]
      (cond
        (not (:success response))
        (do
          (println "Failed to apply staff discount, reverting toggle")
          (swap! staff-discount-atom assoc
            :apply false
            :disabled false))

        :else
        (do
          (println "Staff discount applied successfully")
          (swap! staff-discount-atom assoc
            :disabled false
            :apply true))))))

(defn remove-staff-discount [app-atom cart-summary-atom staff-discount-atom]
  (swap! staff-discount-atom assoc :disabled true)

    ;; Remove staff discount
  (let [staff-payments (model/payment-type-list @cart-summary-atom "Staff")]
    (cond
      (not (seq staff-payments))
      (swap! staff-discount-atom assoc :disabled false)

      :else
      (doseq [payment staff-payments]
        (model/remove-payment app-atom (:payment_uuid payment)
          (fn [response]
            (swap! staff-discount-atom assoc :disabled false)))))))

(rum/defc staff-discount-callout < rum/reactive cmn/cursors
  [app-atom cart-summary-atom]
  (let [{:keys [user discount_level]} (cmn/curact cart-summary-atom [:user])
        staff-discount-atom (cmn/cursor-in cart-summary-atom [:applystaffdiscount])
        apply-staff-discount? (cmn/curact staff-discount-atom [:apply])
        disabled? (cmn/curact staff-discount-atom [:disabled])]
    (when discount_level
      [:aside {:class "card card--no-hover checkout-callout-card text-card text-card--medium"}
       [:div {:class "flex-grid-group flex-grid-group--flush-force flex-grid-group--valign-middle flex-grid-group--align-right"}
        [:div {:class "flex-grid-block flex-grid-block--fluid flex-grid-block--grow-1"}
         [:div {:class "flex-grid-content"}
          [:div {:class "flex-grid-group flex-grid-group--flush-force flex-grid-group--no-wrap flex-grid-group--valign-middle"}
           [:div {:class "flex-grid-block flex-grid-block--fluid flex-grid-block--shrink-0"}
            [:div {:class "flex-grid-content"}
             [:i {:class "icon icon--block icon--medium-large icon--yc-icon-pink"}]]]
           [:div {:class "flex-grid-block flex-grid-block--fluid flex-grid-block--grow-1"}
            [:div {:class "flex-grid-content"}
             [:p {:class "yc-paragraph yc-paragraph--flush"}
              [:b "Apply your staff discount to this order?"]]]]]]]
        [:div {:class "flex-grid-block flex-grid-block--fluid flex-grid-block--shrink-0"}
         [:div {:class "flex-grid-content"}
          [:label {:for "staff-discount-toggle" :class "toggle-label"}
           [:input
            {:type "checkbox"
             :id "staff-discount-toggle"
             :name "applystaffdiscount"
             :class "toggle js-mc-discount-toggle"
             :checked apply-staff-discount?
             :disabled disabled?
             :on-change
             (fn [e]
               (let [checked (.-checked (.-target e))]
                 (if checked
                   (add-staff-discount app-atom cart-summary-atom staff-discount-atom)
                   (remove-staff-discount app-atom cart-summary-atom staff-discount-atom))))}]
           [:span {:class "toggle__graphic-wrapper"}
            [:span {:class "toggle__graphic"}]]]]]]])))

(rum/defc voucher-status-display < rum/reactive cmn/cursors
  [app-atom cart-summary-atom]
  (let [voucher-payments (model/payment-type-list (rum/react cart-summary-atom) "Voucher")
        has-vouchers? (not (empty? voucher-payments))]
    [:div {:class "flex-grid-group flex-grid-group--flush-force flex-grid-group--no-wrap flex-grid-group--valign-middle"}
     [:div {:class "flex-grid-block flex-grid-block--fluid flex-grid-block--shrink-0"}
      [:div {:class "flex-grid-content"}
       [:i {:class "icon icon--block icon--medium-large icon--gift-card"}]]]
     [:div {:class "flex-grid-block flex-grid-block--fluid flex-grid-block--grow-1"}
      [:div {:class "flex-grid-content"}
       (if has-vouchers?
         [:p {:class "yc-paragraph yc-paragraph--flush"}
          [:span {:class "text-pill text-pill--medium text-pill--success"} "Success!"]
          " " [:b "Voucher redeemed."]]
         [:p {:class "yc-paragraph yc-paragraph--flush"}
          [:b "Have a Yuppiechef voucher?"]])]]]))

(rum/defc voucher-action-button < rum/reactive cmn/cursors
  [app-atom cart-summary-atom]
  (let [voucher-payments (model/payment-type-list (rum/react cart-summary-atom) "Voucher")
        has-vouchers? (not (empty? voucher-payments))]
    (if has-vouchers?
      [:a {:href "#"
           :class "button button--raised button--default button--full button--secondary button--bordered"
           :on-click #(grid/open-modal app-atom :cart/redeem-voucher {})}
       [:span {:class "button__text"} "View vouchers"]]
      [:a {:href "#"
           :class "button button--raised button--default button--full button--primary"
           :on-click #(grid/open-modal app-atom :cart/redeem-voucher {})}
       [:span {:class "button__text"} "Redeem voucher"]])))

(rum/defc gift-voucher-callout < rum/reactive cmn/cursors
  [app-atom cart-summary-atom]
  [:aside {:class "card card--no-hover checkout-callout-card text-card text-card--medium"}
   [:div {:class "flex-grid-group flex-grid-group--flush-force flex-grid-group--valign-middle"}
    [:div {:class "flex-grid-block flex-grid-block--l-2-3"}
     [:div {:class "flex-grid-content"}
      (voucher-status-display app-atom cart-summary-atom)]]
    [:div {:class "flex-grid-block flex-grid-block--l-1-3"}
     [:div {:class "flex-grid-content"}
      (voucher-action-button app-atom cart-summary-atom)]]]])

(rum/defc callouts-section < rum/reactive cmn/cursors
  [app-atom cart-summary-atom]
  "Returns a list of callout components in the correct order matching the master file"
  (let [{:keys [user] :as cart-summary} (rum/react cart-summary-atom)
        {:keys [discount_level]} user
        voucher-payments (model/payment-type-list cart-summary "Voucher")
        normaldelivery (model/has-physical-items? cart-summary)

        show-voucher-form?
        (and
          (pos? (or (get-in cart-summary [:totals :total]) 0))
          (or
            (not (empty? (filter :forregistryitem_uuid (:items cart-summary))))
            normaldelivery
            (:voucher_override_group user)))]

    (list
      (when discount_level
        (rum/with-key (staff-discount-callout app-atom cart-summary-atom) "staff-discount"))
      (when show-voucher-form?
        (rum/with-key (gift-voucher-callout app-atom cart-summary-atom) "voucher")))))

(rum/defc discount-line [payment]
  [:article
   {:class "card card--no-hover cart-item cart-item--is-discount"
    :key (str "staff-discount-" (:payment_uuid payment))}
     [:div {:class "cart-item__content"}
      [:figure {:class "cart-item__hero"}
       [:img
        {:src
         (u/cloudinary
           (or (:public_id payment) "contentdocs/1155/otherpicture520190920130656")
           {:bo "24px_solid_rgb:fff" :c "lpad" :f "auto" :h 256 :q "auto" :w 256 :b "white"})
         :alt ""
         :class "yc-simple-image yc-simple-image--full cart-item__image"}]]
      [:div {:class "cart-item__description"}
       [:h2 {:class "cart-item__title"}
        (case (:pmttype payment)
          "Staff" "Staff Discount"
          "Trade" "Trade Discount"
          "Registry Purchase" "Registry Credit"
          (str (:pmttype payment)))]]]
     [:footer {:class "cart-item__footer"}
      [:p {:class "cart-item__subtotal"}
       [:span {:class "u-text-red"}
        "-R" (u/currency-format (Math/abs (:amount payment)))]]]])

;; New modern discounts section component
(rum/defc discounts-section < rum/reactive cmn/cursors
  [app-atom cart-summary-atom]
  "Renders discounts in the new modern card-based design"
  (let [cart-summary (rum/react cart-summary-atom)

        discount-payments
        (concat
          (model/payment-type-list cart-summary "Staff")
          (model/payment-type-list cart-summary "Trade"))

        ;; Registry Purchase is prepaid gift credit, not a discount — own section
        registry-payments (model/payment-type-list cart-summary "Registry Purchase")]

    (list
      (when-not (empty? discount-payments)
        (into
          [:section
           {:key "discounts-applied"
            :class "cart-item-list cart-item-list--is-group"}
           [:h2 {:class "cart-list-heading"} "Discounts applied:"]]
          (map discount-line discount-payments)))

      (when-not (empty? registry-payments)
        (into
          [:section
           {:key "registry-credit"
            :class "cart-item-list cart-item-list--is-group"}
           [:h2 {:class "cart-list-heading"} "Registry credit applied:"]]
          (map discount-line registry-payments))))))



